import React from "react"
import TooltipComponent from "components/ui/Tooltip"
import { Typography } from "@mui/material"

type Props = React.HTMLAttributes<HTMLDivElement> & {
  fullText: string
  truncationSize?: number
}

const TruncatedTextComponent = ({ fullText, truncationSize }: Props) => {
  const truncationLength = truncationSize || 50
  const text = fullText || ""
  const truncationNeeded = text.length > truncationLength

  return (
    <>
      {truncationNeeded && (
        <TooltipComponent tooltipText={text}>
          <Typography component="div">
            {text.substring(0, truncationLength)}&hellip;
          </Typography>
        </TooltipComponent>
      )}
      {!truncationNeeded && <Typography component="div">{text}</Typography>}
    </>
  )
}

export default TruncatedTextComponent
